import React, { useState } from "react";
import { colors } from "../../maps/colors";
import { Co2Sharp } from "@mui/icons-material";

const Placement = ({ item, color, products, alerts }) => {
  const { boundingBoxPr, label, layers } = item;
  const [showModal, setShowModal] = useState(false);
  const FIFO = alerts
    .filter(
      (alert) => alert.eventSubType === "FIFO" && alert.data.details.placements
    )
    .flatMap((alert) => alert.data.details.placements)
    .find((placement) => {
      return placement.placementId === item._id;
    }); // Replace with desired ID

  const MISSED_PLACE = alerts
    .filter(
      (alert) => alert.eventSubType !== "FIFO" && alert.data.details?.misplaced
    )
    .flatMap((alert) => alert.data.details.misplaced)
    .find((placement) => {
      return placement.placementId === item._id;
    }); // Replace with des
  const layersCount = layers && layers.length > 0 ? layers.length : 0;

  let borderStyle = "border-solid";
  let borderRadius = "rounded-full";
  switch (label) {
    case "six_pack":
      borderRadius = "rounded-lg";
      break;
    case "dash_circle":
      borderStyle = "border-dotted";
      break;
    case "circle":
      break;
    case "cereal":
      borderRadius = "rounded-none";
      break;
    default:
      borderRadius = "rounded-none";
      break;
  }

  let circleColor = "transparent";
  if (FIFO) {
    circleColor = "orange";
  }
  if (MISSED_PLACE) {
    circleColor = "red";
  }
  const handleClick = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const style = {
    left: `${boundingBoxPr.xMin}%`,
    top: `${boundingBoxPr.yMin}%`,
    width: `${boundingBoxPr.xMax - boundingBoxPr.xMin}%`,
    height: `${boundingBoxPr.yMax - boundingBoxPr.yMin}%`,
    background: `#fff ur l('${
      products?.[item.productId]?.imageUrl ||
      products?.[item.layers?.[0].productId]?.imageUrl
    }') center center no-repeat`,
  };

  return (
    <div>
      <div
        className={`absolute flex justify-center items-center bor der ${borderStyle} ${borderRadius}`}
        style={{
          ...style,
          // border: `2px solid ${circleColor}`,
          // backgroundColor: circleColor,
        }}
        // onClick={handleClick}
        title={
          products?.[item.productId]?.name ||
          products?.[item.layers?.[0].productId]?.name ||
          "Product"
        }
      >
        {(products?.[item.productId]?.imageUrl ||
          products?.[item.layers?.[0].productId]?.imageUrl) && (
          <img
            src={
              products?.[item.productId]?.imageUrl ||
              products?.[item.layers?.[0].productId]?.imageUrl
            }
            alt=""
            className="h-4/5 w-3/4 object-cover"
            style={{
              mixBlendMode: "multiply",
              width: "auto", // Let the image take its natural width
              height: "55px", // Let the image take its natural height
              border: `4px solid ${circleColor}`,
            }}
          />
        )}

        {/* {layersCount > 0 && (
          <div className="absolute top-1 right-0 bg-red-500 text-white rounded-full px-2 text-xs font-bold opacity-75    -right-2 -top-2">
            {layersCount}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Placement;
